var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"mi-ju-shi-chan"},[_c('PageBlock',{attrs:{"title":"蜜桔市场行情"}},[_c('div',{staticClass:"content"},[_c('div',{ref:"chart",staticStyle:{"width":"100%","height":"360px"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }